import { BMDivider } from "@traveloka/district-bloom";
import BMView from "../../../../../components/View/BMView";
import SelectNonEmployeeStepper from "./SelectNonEmployeeStepper";

export default function SelectNonEmployeeHotelContent() {
  return (
    <BMView spacing="lg">
      <SelectNonEmployeeStepper name="adults" type="adult" />
      <BMDivider type="SUBTLE" />
      <SelectNonEmployeeStepper name="childrenAges" type="childrenAges" />
    </BMView>
  );
}
